import { isStructuredLocationValidationEnabled } from "../../../shared/location/isStructuredLocationValidationEnabled";
import { useNativeContext } from "../../../shared/props/NativeContext";
import { useViewjobProctorAllocation } from "../../proctor/__generated__/ViewjobProctorContext";
import { JsoStructuredLocationValidationTst } from "../../proctor/__generated__/ViewjobProctorSpecifications";

/**
 * Hook to check if structured location validation is enabled
 * Reads the viewjob allocation context plus the shared
 * `nativeContext.proctorGroups` override blob and forwards them to the
 * shared predicate.
 */
export function useIsStructuredValidationEnabled(): boolean {
  const nativeContext = useNativeContext();
  const { value: appBucket } = useViewjobProctorAllocation(JsoStructuredLocationValidationTst);
  return isStructuredLocationValidationEnabled(appBucket, nativeContext?.proctorGroups);
}
